import { Column, IRowNode } from 'ag-grid-community'
import { ColumnType } from '../../../commons/AgGrid'
import { getLabel } from '../../../../../lib/commons/i18nLabel'

const MULTI_PROPERTY_DELIMITER: string = ','

export const processAutoCompleteCellFromClipboard = (
  targetColumn: Column,
  targetNode: IRowNode | null | undefined,
  clipboardValue: any,
  gridOptionContext: object
) => {
  const colDef = targetColumn.getColDef()
  const { type, cellEditorParams } = colDef
  if (!type?.includes(ColumnType.autocomplete)) return

  if (cellEditorParams.entity) {
    const options = gridOptionContext[cellEditorParams.entity]
    return options.find(o =>
      [getLabel(o.nameI18n), o.name, o.displayName, o.officialName]
        .filter(v => !!v)
        .includes(clipboardValue)
    )
  } else if (cellEditorParams.searchCacheKey && cellEditorParams.search) {
    const cachedEntities = gridOptionContext[cellEditorParams.searchCacheKey]
    const cachedEntity = cachedEntities
      ? cachedEntities[clipboardValue]
      : undefined
    if (cachedEntity) return cachedEntity

    cellEditorParams.search(clipboardValue).then(entities => {
      if (!targetNode || !entities || entities.length === 0) return
      targetNode.setDataValue(targetColumn, entities[0])
      if (cachedEntities) {
        cachedEntities[clipboardValue] = entities[0]
      } else {
        gridOptionContext[cellEditorParams.searchCacheKey] = {
          [clipboardValue]: entities[0],
        }
      }
    })
  }
  return clipboardValue
}

export const processSelectNotSuctomEnumCellForClipboard = (
  targetColumn: Column,
  value: string | undefined
) => {
  const colDef = targetColumn.getColDef()
  const { type, cellEditorParams } = colDef
  if (!type?.includes(ColumnType.selectNotCustomEnum)) return ''

  const { options } = cellEditorParams
  if (!options || !value) return ''
  return options.find(o => o.value === value)?.label ?? ''
}
export const processSelectNotSuctomEnumCellFromClipboard = (
  targetColumn: Column,
  clipboardValue: any,
  valueDelimiter: string = MULTI_PROPERTY_DELIMITER
) => {
  const colDef = targetColumn.getColDef()
  const { type, cellEditorParams } = colDef
  if (!type?.includes(ColumnType.selectNotCustomEnum)) return

  const { options } = cellEditorParams
  if (!options || !clipboardValue) return
  return options.find(o => o.label === clipboardValue)?.value ?? undefined
}
export const processMultiSelectNotSuctomEnumCellForClipboard = (
  targetColumn: Column,
  value: string[] | undefined
) => {
  const colDef = targetColumn.getColDef()
  const { type, cellEditorParams } = colDef
  if (!type?.includes(ColumnType.multiSelectNotCustomEnum)) return ''

  const { options } = cellEditorParams
  if (!options || !value) return ''
  const optionMap: { [value: string]: string } = {}
  options.forEach(v => {
    optionMap[v.value] = v.label
  })
  return value
    .map(v => optionMap[v] ?? '')
    .filter(v => !!v)
    .join(MULTI_PROPERTY_DELIMITER)
}
export const processMultiSelectNotSuctomEnumCellFromClipboard = (
  targetColumn: Column,
  clipboardValue: any,
  valueDelimiter: string = MULTI_PROPERTY_DELIMITER
) => {
  const colDef = targetColumn.getColDef()
  const { type, cellEditorParams } = colDef
  if (!type?.includes(ColumnType.multiSelectNotCustomEnum)) return

  const { options } = cellEditorParams
  if (!options) return
  const labels = clipboardValue.split(valueDelimiter).filter(v => !!v)
  return options
    ? options
        .filter(v => labels.includes(v.label))
        .filter(v => !!v)
        .map(v => v.value)
    : []
}
